<template>
    <div style="margin-top: 2vw;">
        <div v-for="item in smartPitchList" class="smartPitchList">
            <p class="group">{{ item.group }}</p>
            <div class="smartPitchItem">
                <div v-for="i in item.cameras" @click="videoFn(item, i)" class="camera">
                    <img src="@/assets/img/smartPitch/SmartPitch.svg" alt="">
                    <p class="cameraName">{{ i.name }}</p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "smartPitch",
    data() {
        return {
            smartPitchList: [],
        }
    },
    mounted() {
        this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl('这是智慧球场列表'), true, true, 1);

        this.getList();
    },
    methods: {
        getList() {
            this.$server.getSmartPitchDevices()
                .then(res => {
                    this.smartPitchList = res.data;
                })
        },
        videoFn(pitch, video) {
            this.$router.push({
                path: '/about/smartPitch/camera',
                query: {
                    pitch: pitch.stream,
                    video: JSON.stringify(video)
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.smartPitchList {
    .group {
        font-size: 28px;
        line-height: 4vw;
        color: #fff;
        text-align: left;
        margin-left: 3%
    }

    .smartPitchItem {
        display: flex;
        flex-wrap: wrap;
        border-radius: 6px;
        overflow: hidden;

        .camera {
            width: 30%;
            margin-left: 3%;
            background-color: rgba(245, 248, 255, .1);
            box-shadow: 0px 17.9077px 17.9077px rgba(0, 50, 174, 0.08);

            img {
                width: 100%;
            }

            .cameraName {
                color: rgba(255, 255, 255, .8);
                font-size: 28px;
                font-family: PingFangMedium;
                padding-left: 1vw;
                line-height: 2.5vw;
                text-align: left;
            }
        }
    }
}



</style>